import React, { Component } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GreenCheckbox = withStyles({
  root: {
    color: "#1874B9",
    "&$checked": {
      color: "#0066b2"
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const styles = theme => ({
  btnClose: {
    color: "#fff",
    border: "1px solid",
    background: "#0093DD",
    padding: "6px 16px"
  }
});

class UserMessageHome extends Component {
  state = {
    open: true,
    notAgain: false,
    messageRead: false
  };

  // componentDidMount(){
  //   //RECEBER O PROPS COM O RETORNO DO GET-USUARIO COM A FLAG DE ESCONDER INSTRUÇÕES
  //   this.setState({
  //     open: true
  //   })
  // }

  handleClickOpen = () => {
    this.setState({
      open: true
    });
  };

  handleClose = () => {
    this.setState(
      {
        open: false,
        messageRead: true
      },
      () => {
        this.props.getUserMessageHomeChecked(this.state.notAgain);
        this.props.setUserMessageHomeRead(this.state.messageRead);
      }
    );
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Dialog
          open={this.state.open}
          TransitionComponent={Transition}
          keepMounted
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-slide-title">
            {this.props.titleMessage}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description" align="justify">
              <span
                dangerouslySetInnerHTML={{ __html: this.props.userMessage }}
              />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            {!this.props.modalUserStatusAPI && (
              <FormControlLabel
                control={
                  <GreenCheckbox
                    checked={this.state.notAgain}
                    onChange={this.handleChange("notAgain")}
                    value="notAgain"
                  />
                }
                label="Não exibir novamente"
              />
            )}

            <Button onClick={this.handleClose} className={classes.btnClose}>
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(UserMessageHome);
